import * as React from 'react';
import { InfoIcon, WarningIcon } from '@phosphor-icons/react';
import { cn } from '@/utils/utils';
import { INSET } from '@/components/ui/recipes';

/** What a note says, and so its mark: information (an info mark in the brand ink) or a warning (a warning mark in the warning ink). */
export type NoteTone = 'info' | 'warning';

const TONES: Record<NoteTone, { Mark: React.ElementType; colour: string }> = {
  info: { Mark: InfoIcon, colour: 'text-lureo-brand-ink' },
  warning: { Mark: WarningIcon, colour: 'text-lureo-warning-ink' },
};

/** Lureo's note: a brand-tinted inset in a panel or form that explains or advises. A tone gives it its mark; `icon` is for any other glyph. */
export function Note({ tone, icon, children, className }: { tone?: NoteTone; icon?: React.ReactNode; children: React.ReactNode; className?: string }) {
  const Mark = tone && TONES[tone].Mark;
  return (
    <div className={cn(INSET, 'flex gap-2.5 px-3.5 py-3 font-lureo-font-ui text-lureo-13 leading-[1.45] text-lureo-ink', className)}>
      {(Mark || icon) && (
        <span className={cn('mt-0.5 shrink-0 [&_svg]:h-4 [&_svg]:w-4', tone ? TONES[tone].colour : 'text-lureo-brand-ink')}>{Mark ? <Mark /> : icon}</span>
      )}
      <div className="min-w-0 flex-1">{children}</div>
    </div>
  );
}
